export function index(includeCompetences = false) {
    return axios.get(route('api.manage.companies.competence-templates') + (includeCompetences ? '?include=competences,jobs' : ''))
        .then(response => response.data);
}

export function items() {
    return axios.get(route('api.manage.companies.competences') + '?limit=9999')
        .then(response => response.data);
}

export function store(data) {
    return axios.post(route('api.manage.companies.competence-templates'), data)
        .then(response => response.data);
}

export function destroyItem(questionId) {
    return axios.delete(route('api.manage.companies.competence-templates.competences.destroy', {competenceId: questionId}));
}

export function updateItem(questionId, data) {
    return axios.patch(route('api.manage.companies.competence-templates.competences.update', {competenceId: questionId}), data)
        .then(response => response.data);
}

export function linkJobs(questionId, data) {
    return axios.post(route('api.manage.companies.competence-templates.competences.jobs.link', {competenceId: questionId}), data)
        .then(response => response.data);
}

export function updateSortOrders(data) {
    return axios.patch(route('api.manage.companies.competence-templates.sort-order.update'), data)
        .then(response => response.data);
}

export function updateItemSortOrders(templateId, data) {
    return axios.patch(route('api.manage.companies.competence-templates.competences.sort-order.update', {templateId: templateId}), data)
        .then(response => response.data);
}

export function storeItem(templateId, data) {
    return axios.post(route('api.manage.companies.competence-templates.competences.store', {templateId: templateId}), data)
        .then(response => response.data);
}


export function show(templateId) {
    return axios.get(route('api.manage.companies.competence-templates.show', {templateId: +templateId}) + '?include=competences');
}

export function update(templateId, data) {
    return axios.patch(route('api.manage.companies.competence-templates.update', {templateId: templateId}), data)
        .then(response => response.data);
}

export function destroy(templateId) {
    return axios.delete(route('api.manage.companies.competence-templates.destroy', {templateId: templateId}));
}

export function duplicate(templateId) {
    return axios.post(route('api.manage.companies.competence-templates.duplicate', {templateId: templateId}));
}
